import store from "../../store";

const host_account = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX;
const account = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace('/', '');

export default {
  EMAIL_APPROVE: host_account + 'profile/email/approve/',
  TOKEN_ALIVE: host_account + 'authenticate/token/alive/',
  FORGET_PASSWORD: host_account + 'forget/password/',
  CHANGE_PASSWORD: host_account + 'change/forget/password/',
  RECOVERY_EMAIL: host_account + 'registration/resend/',

  LANGUAGE_SELECTOR: host_account + 'languages/',
  LANGUAGES_SELECTOR_LIST: host_account + 'languages/',
  CHOICES_PROFILE: {
    BASE: host_account + 'choices/',
    IDENTITY_KIND: 'identity/kind/',
    IDENTITY_SEX: 'identity/sex/',
    EDUCATION_LEVEL: 'education/level/',
    CONTACT_KIND: 'contact/kind',
    RELATIVE_RELATION: 'relative/relation/',
    LANGUAGE_LEVEL: 'language/level/',
    MARITAL_STATUS: 'user/marital_status/',
    getUrl: function (urlname) {
      return this.BASE + this[urlname];
    }
  },


  getUrl(urlname, action) {
    let url = store.getters['urls/getPattern'](
      account,
      urlname,
      action
    );
    if (url !== '')
      return process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', '') + url;
    else
      return ''

  },
  getUrlAllowed(urlname, action) {
    return store.getters['urls/getAllowed'](
      account,
      urlname,
      action
    );
  },


  PROFILE_URLS: {
    BASE: host_account + 'user/<user-uid>/',
    SELF: 'profile/',
    USERLANGUAGES: {
      LIST: 'languages/',
      CREATE: 'languages/',
      UPDATE: 'languages/<id>/',
      DELETE: 'languages/<id>/',
    },
    CHANGE_EMAIL: {
      UPDATE: 'profile/email/change/',
    },
    CHANGE_PASSWORD: {
      UPDATE: 'profile/password/change/',
    },
    IDENTITIES: {
      LIST: 'identities/',
      CREATE: 'identities/',
      UPDATE: 'identities/<id>/',
      DELETE: 'identities/<id>/',
    },
    EDUCATIONS: {
      LIST: 'educationdocuments/',
      CREATE: 'educationdocuments/',
      UPDATE: 'educationdocuments/<id>/',
      DELETE: 'educationdocuments/<id>/'
    },
    SNILSS: {
      LIST: 'snilss/',
      CREATE: 'snilss/',
      UPDATE: 'snilss/<id>/',
      DELETE: 'snilss/<id>/'
    },
    RELATIVES: {
      LIST: 'relatives/',
      CREATE: 'relatives/',
      UPDATE: 'relatives/<id>/',
      DELETE: 'relatives/<id>/'
    },
    PHONES: {
      LIST: 'phones/',
      CREATE: 'phones/',
      UPDATE: 'phones/<id>/',
      DELETE: 'phones/<id>/',
      SELECTOR: 'selectors/phones/',
    },
    EMAILS: {
      LIST: 'emails/',
      CREATE: 'emails/',
      UPDATE: 'emails/<id>/',
      DELETE: 'emails/<id>/',
      SELECTOR: 'selectors/emails/',
    },
    ADDRESSES: {
      LIST: 'addresses/',
      CREATE: 'addresses/',
      UPDATE: 'addresses/<id>/',
      DELETE: 'addresses/<id>/',
      SELECTOR: 'selectors/addresses/',
    },
    getNamedUrl: function (namespace, urlname) {
      return this.BASE + this[namespace][urlname]
    },
    getUrl: function (urlname) {
      return this.BASE + this[urlname];
    }
  },
}
